import { useQuery } from "@tanstack/react-query";
import { StoreService } from "@/generated/services/StoreService";

export function useFetchStore(
  memberId: number,
  fspNbr?: string,
  holdersFetched?: boolean,
) {
  return useQuery({
    queryKey: ["store", memberId],
    queryFn: async () => {
      const response = await StoreService.getMembersStores(
        memberId,
        Number(process.env.NEXT_PUBLIC_RETAILER_ID) || 0,
      );
      return response || [];
    },
    enabled: !!memberId && !!fspNbr && holdersFetched === true, // Only run query if memberId, fspNbr exist and holders are fetched
  });
}
